/* Theatre screens: the list, booking, the case and Settings > Theatres
 * (docs/plans/phase2-theatre.md §6). States are words plus shapes: a recorded checklist step
 * is a filled marker, the next one outlined, later ones a hairline. Tokens only. */

.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.meta {
  margin: 0;
  color: var(--graphite);
  font: var(--t-small);
}

.dayNav {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: var(--space-3);
}

.time {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.row {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.row > * {
  flex: 1 1 12rem;
  min-width: 0;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-3);
}

.facts {
  display: grid;
  grid-template-columns: max-content 1fr;
  gap: var(--space-2) var(--space-5);
  margin: 0;
}

.facts dt {
  color: var(--graphite);
  font: var(--t-small);
}

.facts dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.prose {
  max-width: 75ch;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.55;
}

.money {
  font-variant-numeric: tabular-nums;
}

.code {
  margin-right: var(--space-2);
}

/* The four checklist steps, in order. */
.steps {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin: 0;
  padding: 0;
  list-style: none;
}

.step {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-left: var(--space-5);
  border-left: 2px solid var(--rule);
}

.step[data-state='done'] {
  border-left-color: var(--ink);
}

.step[data-state='next'] {
  border-left-style: dashed;
  border-left-color: var(--border-strong);
}

.stepHead {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.stepTitle {
  margin: 0;
  font: var(--t-body-strong);
}

.answers {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  list-style: none;
}

.answer {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  font: var(--t-body);
}

.answerWord {
  min-width: 7rem;
  font: var(--t-body-strong);
}

.itemBlock {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  padding-bottom: var(--space-4);
  border-bottom: 1px solid var(--rule);
}

.noteSection {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.noteHeading {
  margin: 0;
  font: var(--t-body-strong);
}

.itemMain {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.itemMeta {
  color: var(--graphite);
  font: var(--t-small);
}

.itemTitle {
  margin: 0;
}

.phaseList {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.phaseItem {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
  min-height: 44px;
  padding: var(--space-2) 0;
  border-bottom: 1px solid var(--rule);
}
